import { Controller } from 'stimulus'
import CheckoutController from './checkout_controller'

export default class FormChildEligibilityController extends Controller {
  declare childFirstNameTarget: HTMLInputElement
  declare childLastNameTarget: HTMLInputElement
  declare childDateOfBirthTarget: HTMLInputElement
  declare insuranceMemberIdTarget: HTMLInputElement
  static targets = [
    'childFirstName',
    'childLastName',
    'childDateOfBirth',
    'insuranceMemberId',
  ]

  declare checkoutOutlet: CheckoutController
  static outlets = ['checkout']

  connect() {
    this.childFirstNameTarget.focus()
    this.setInitialValues()
  }

  setInitialValues() {
    const eligibilityData = this.checkoutOutlet.signupData.eligibility
    if (!eligibilityData || eligibilityData.eligibility_type !== 'child') {
      return
    }

    const {
      child_first_name,
      child_last_name,
      child_date_of_birth,
      insurance_member_id,
    } = eligibilityData

    this.childFirstNameTarget.value = child_first_name
    this.childLastNameTarget.value = child_last_name
    this.childDateOfBirthTarget.value = child_date_of_birth
    this.insuranceMemberIdTarget.value = insurance_member_id
  }
}
